import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Injectable, inject} from '@angular/core';
import {SearchScopeConfiguration} from './searchscopeconfiguration';
import {FilterResult} from '../../resource/filterresult';
import {BaseApiService} from '../../core/services/base-api.service';
import {SupportedLocaleConfigurationService} from './supportedlocaleconfiguration.service';

@Injectable()
export class SearchScopeConfigurationService extends BaseApiService {
  private localeService = inject(SupportedLocaleConfigurationService);

  public getAll(): Observable<SearchScopeConfiguration[]> {
    const attributes = [
      this.getAttr('ObjectID'),
      this.getAttr('DisplayName'),
      this.getAttr('Description'),
      this.getAttr('UsageKeyword'),
      this.getAttr('Order'),
      this.getAttr('SearchScopeContext'),
      this.getAttr('SearchScope'),
      this.getAttr('SearchScopeResultObjectType'),
      this.getAttr('SearchScopeColumn'),
      this.getAttr('SortAttribute'),
      this.getAttr('SortDirection'),
    ].filter(attr => attr !== null);

    return this.getWithLocale<FilterResult>(
      '/' + this.getType('SearchScopeConfiguration'),
      attributes,
      10000,
      this.localeService.getSupportedLocaleConfiguration(),
    ).pipe(map(response => this.mapSearchScopeConfigurations(response.Results)));
  }

  private mapSearchScopeConfigurations(searchscopes: any): SearchScopeConfiguration[] {
    let finalSearchScopes: SearchScopeConfiguration[] = [];
    searchscopes.forEach(obj => {
      finalSearchScopes.push(this.toSearchScopeConfiguration(obj));
    });
    return finalSearchScopes;
  }

  private toSearchScopeConfiguration(r: any): SearchScopeConfiguration {
    let scope = <SearchScopeConfiguration>{
      id: r[this.getAttr('ObjectID')],
      displayname: r[this.getAttr('DisplayName')],
      description: r[this.getAttr('Description')],
      order: parseInt(r[this.getAttr('Order')]),
      attributesearched: r[this.getAttr('SearchScopeContext')],
      xpath: r[this.getAttr('SearchScope')],
      resultobjecttype: r[this.getAttr('SearchScopeResultObjectType')],
      attributedisplayed: r[this.getAttr('SearchScopeColumn')],
      usagekeyword: r[this.getAttr('UsageKeyword')],
      sortingattribute: r[this.getAttr('SortAttribute')],
    };
    scope.sortdirection = null;
    if (
      r[this.getAttr('SortDirection')] == null ||
      r[this.getAttr('SortDirection')] === 'asc' ||
      r[this.getAttr('SortDirection')] == 'desc'
    ) {
      scope.sortdirection = r[this.getAttr('SortDirection')];
    }
    return scope;
  }
}
